import Datatable from "./datatable_controller";
import {put} from "@rails/request.js";

// Connects to data-controller="attendee-datatable"
export default class extends Datatable {

  static values = {
    eventId: String,
    personalized: { type: Boolean, default: true },
    subeventDate: String
  }
  connect() {
    super.connect()

    // Expand/collapse the attendee detail panel when the leading chevron is clicked.
    // The panel HTML is carried on the chevron button's data-attendee-expander-panel.
    $(this.tableTarget).on('click', '.attendee-expander', (event) => {
      event.preventDefault()
      const btn = event.currentTarget
      const tr = btn.closest('tr')
      const row = this.dataTable.row(tr)
      if (row.child.isShown()) {
        row.child.hide()
        tr.classList.remove('attendee-row-expanded')
      } else {
        row.child(btn.dataset.attendeeExpanderPanel).show()
        tr.classList.add('attendee-row-expanded')
      }
    })
  }

  get columns() {
    // Unified column order for both personalized and non-personalized events.
    // Must stay in sync with PurchasedTicketListingDatatable#view_columns / data.
    return [
      {data: 'expander', orderable: false, className: 'attendee-expander-col'},
      {data: 'attendee'},
      {data: 'ticket_type'},
      {data: 'order_id'},
      {data: 'order_date'},
      {data: 'check_in_status'},
      {data: 'checked_in_at'},
      {data: 'actions'},
    ]
  }

  // Append the selected day to every datatable request (used by the day filter).
  manipulateData(data) {
    if (this.subeventDateValue) data['subevent_date'] = this.subeventDateValue
    return data
  }

  // Day filter: a <select> change or a tab-button click sets the active day,
  // reloads the table, and refreshes the attendance-progress card for that day.
  selectDay(event) {
    const el = event.currentTarget
    const date = el.dataset.date || el.value
    if (!date) return

    this.subeventDateValue = date

    // Tab UI: move the active class to the clicked tab.
    if (el.classList.contains("attendee-day-tab")) {
      this.element.querySelectorAll(".attendee-day-tab").forEach((t) => t.classList.remove("attendee-day-tab--active"))
      el.classList.add("attendee-day-tab--active")
    }

    if (this.dataTable) this.dataTable.ajax.reload()
    this.refreshAttendanceCard(date)
  }

  // Point the day-of attendance card at the given day (if a date is supplied) and
  // re-fetch its stats, so the card stays in sync with the table after a day change
  // or a manual check-in toggle.
  refreshAttendanceCard(date = null) {
    const cardEl = document.querySelector("[data-controller~='attendance-progress']")
    if (!cardEl) return

    if (date) {
      const base = cardEl.getAttribute("data-attendance-progress-url-value")
      if (base) {
        const url = new URL(base, window.location.origin)
        url.searchParams.set("subevent_date", date)
        // Updating the data-* attribute updates the Stimulus urlValue the controller reads.
        cardEl.setAttribute("data-attendance-progress-url-value", url.pathname + url.search)
      }
    }

    const ctrl = this.application.getControllerForElementAndIdentifier(cardEl, "attendance-progress")
    if (ctrl && typeof ctrl.refresh === "function") ctrl.refresh()
  }

  get searching() {
    return true
  }

  get ordering() {
    return false
  }

  get lengthChange() {
    return false
  }

  async toggleSwitch(event) {
    const currentElement = event.currentTarget;
    const status = currentElement.dataset.statusValue == "true"
    const url = currentElement.dataset.urlValue;

    const response = await put(url, {
      contentType: "application/json",
      responseKind: "json",
    });

    if (response.ok) {
      const data = await response.json;

      if (data.success) {
        // Legacy on/off switch (kept for any other caller).
        currentElement.classList.toggle("toggle-btn-on");
        currentElement.setAttribute("data-status-value", `${!status}`);

        // Reload the table so the row's status pill, "Checked In At", and Check In
        // button all re-render server-side; keep the day-of card in sync.
        if (this.dataTable) this.dataTable.ajax.reload(null, false);
        this.refreshAttendanceCard();

        if (data.message) displayFlashMessage('success', data.message);
      } else {
        displayFlashMessage('error', data.message || 'Failed to update check-in status');
      }
    } else {
      const data = await response.json;
      displayFlashMessage('error', data.message || 'Failed to update check-in status');
    }
  }
}
